import React from "react";
import _ from 'underscore';

var auctionKeyToLabelMap = {
    // Common fields
    'Neighborhood': 'neighborhood',
    'View Type': 'viewType',
    'Property Type': 'propertyType',
    'Property Subtype': 'propertySubtype',
    'Units': 'units',
    'Year Built': 'yearBuilt',
    'Property Style': 'propertyStyle',
    'Architectural Style': 'architecturalStyle',
    'Style Type': 'styleType',
    'Exterior': 'exterior',
    'Flooring': 'flooring',
    'Roofing': 'roofing',
    'Appliances': 'appliances',
    'Cooling System': 'coolingSystem',
    'Heating Fuel': 'heatingFuel',
    'Heating System': 'heatingSystem',
    // UK/Ireland specific
    'Garden': 'hasGarden',
    'Parking': 'hasParking',
    'Parking Spaces': 'parkingSpaces',
};

// Format value for display (handle booleans)
var formatValue = function(value, key) {
    if (typeof value === 'boolean') {
        return value ? 'Yes' : null;
    }
    return value;
};

export var RealEstateCharacteristics = function(props) {
    var auction = props.auction;

    if (!auction) return null;
    if (!auction.isRealEstate) return null;

    var data = _.chain(auctionKeyToLabelMap)
        .mapObject(function(auctionKey, label) {
            var rawValue = auction[auctionKey];
            var value = formatValue(rawValue, auctionKey);
            if (!value) return null;
            return {
                label: label,
                value: value,
            };
        })
        .compact()
        .value();

    if (!data.length) return null;

    return (
        <div className="al-auction-real-estate-more">
            <h5>More Information</h5>
            <div className="al-auction-real-estate-more-cols">
                {_(data).map(function(item) {
                    return (
                        <div
                            className="al-auction-real-estate-more-item"
                            key={item.label}
                        >
                            <label>{item.label}</label>
                            <div>{item.value}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
